export const Constant =
{
    BASIC_INFO: {
        tabTitle: "", tabHeaderTitle: "", tabKey: "",
        fields: ["name", "brief_name", "local_nationality", "bd_status", "bd_note", "local_province", "local_area"]
    }
}

export const BDStatus = [
    "1-TARGET - Potential",
    "1-TARGET - To BD now",
    "2-APPROACH M",
    "2-APPROACH E - Call",
    "2-APPROACH E - Email",
    "2-APPROACH E - Nhắn tin",
    "2-APPROACH E - Meeting",
    "3-TO FOLLOW UP - S",
    "3-TO FOLLOW UP - L",
    "4- Connect Free",
    "4- Run job / CMNL",
    "5- T&C confirmed",
    "6-Negotiating contract",
    "7-Contract signed"
]

export const BDStatusOption = BDStatus.map(item => {
    return {
        value: item,
        label: item
    };
})

export const NoteWhenSendCV = [
    "",
    "Check kỹ chất lượng UV",
    "Others",
]

export const NoteWhenSendCVOption = NoteWhenSendCV.map(item => {
    return {
        value: item,
        label: item
    };
})

export const RoleAtEmployer = [
    "Boss",
    "Đầu mối lv với headhunt",
    "Head of HR",
    "Head of Recruitment",
    "Recruiter",
    "Admin",
    "Kế toán thanh toán",
    "Hiring Manager",
    "Others"
]

export const RoleAtEmployerOption = RoleAtEmployer.map(item => {
    return {
        value: item,
        label: item
    };
})

export const BeContactPoint = {
    NA: {title: "N/A", value: 1},
    Yes: {title: "Yes", value: 2},
    No: {title: "No", value: 3}
}

export const BeContactPointOption = Object.values(BeContactPoint).map(item => {
    return {
        value: item.value,
        label: item.title
    };
})

//
// export const EmployerFields = {
//     id: {title: 'Employer ID', type: 'label'},
//     name: {title: 'Tên Employer', type: 'text'},
//     brief_name: {title: 'Tên Employer', type: 'text'},
//     local_nationality: {title: 'Quốc tịch', type: 'option'},
//     bd_status: {title: 'BD Status', type: 'option'},
//     bd_note: {title: 'Note BD', type: 'text'},
//     local_province: {title: 'Location (Tỉnh)', type: 'option'},
//     local_area: {title: 'Location (Miền)', type: 'option'},
//     industry: {title: 'Industry', type: 'text'},
//     about_employer_to_send: {title: 'Thông tin về Employer (to send)', type: 'text'},
//     working_time_to_send: {title: 'Thời gian LV (to send)', type: 'text'},
// }
